import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hr-staffing-staging/artifacts/6wsngqp2_ChatGPT%20Image%20Jun%2025%2C%202026%2C%2002_46_39%20PM.png";

export default function Logo({ variant = "light", to = "/", className = "" }) {
  // variant: 'light' = on white bg (nav) | 'dark' = on dark bg (footer)
  const isDark = variant === "dark";
  return (
    <Link
      to={to}
      data-testid="site-logo"
      aria-label="Advance HR Technologies — Home"
      className={`inline-flex items-center group ${className}`}
    >
      <span
        className={`flex items-center justify-center rounded-xl overflow-hidden ${
          isDark ? "bg-white p-1.5" : ""
        }`}
      >
        <img
          src={LOGO_URL}
          alt="Advance HR Technologies"
          loading="eager"
          className="h-12 sm:h-14 lg:h-16 w-auto object-contain transition-transform group-hover:scale-[1.02]"
        />
      </span>
    </Link>
  );
}
